import styles from './styles';
import prism from './prism';
import * as modes from './modes';
import { breakpoints } from './breakpoints';

export default {
    breakpoints: Array.from(breakpoints),
    colors: {
        ...modes.light,
        modes: { dark: modes.dark, },
    },
    borders: {
        thin: '1px solid'
    }, 
    fonts: {
        body: 'inherit',
        heading: 'inherit',
        monospace: 'Inconsolata',
    },
    fontSizes: [13, 15, 16, 20, 24, 34, 42],
    fontWeights: {
        body: 400,
        heading: 700,
        medium: 600,
        bold: 700,
    },
    lineHeights: {
        body: 1.7,
        heading: 1.3,
    },
    letterSpacings: {
        body: 'normal',
        caps: '0.1em',
    },
    space: [0, 4, 8, 16, 24, 32, 48, 64, 80, 100],
    radii: {
        square: 0,
        soft: 3,
        rounded: 999,
    },
    styles,
    prism
}